import { type ComponentProps } from 'react'
import clsx from 'clsx'
import { AnimatePresence, motion } from 'motion/react'
import { useTranslation } from 'react-i18next'
import { ToggleCard } from 'ui/src/components/ToggleCard/ToggleCard'
import { framerTransitions } from 'ui/src/theme/transitions'
import { autoSwitchToggleCardDescription, autoSwitchToggleCardRoot } from './AutoSwitchToggerCard.css'

type Props = ComponentProps<typeof ToggleCard.Root> & {
  companyName: string
  checked: boolean
  onCheckedChange?: (checked: boolean) => void
}

export const AutoSwitchToggleCard = ({ className, companyName, checked, onCheckedChange, ...props }: Props) => {
  const { t } = useTranslation('purchase-form')

  return (
    <ToggleCard.Root className={clsx(autoSwitchToggleCardRoot, className)} {...props}>
      <ToggleCard.Label>{t('AUTO_SWITCH_FIELD_LABEL')}</ToggleCard.Label>
      <ToggleCard.Switch checked={checked} onCheckedChange={onCheckedChange} />

      <AnimatePresence initial={false}>
        {checked && (
          <motion.div
            initial={{ opacity: 0, height: 0 }}
            animate={{ opacity: 1, height: 'auto' }}
            exit={{ opacity: 0, height: 0 }}
            transition={{ duration: framerTransitions.defaultDuration, ...framerTransitions.easeInOutCubic }}
            style={{ overflow: 'clip' }}
          >
            <ToggleCard.Description className={autoSwitchToggleCardDescription}>
              {t('AUTO_SWITCH_FIELD_MESSAGE', { COMPANY: companyName })}
            </ToggleCard.Description>
          </motion.div>
        )}
      </AnimatePresence>
    </ToggleCard.Root>
  )
}
